<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g :fill="color">
      <path d="M2.75 2.75h16.5v16.5h-16.5z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgStop',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
